module.exports = __webpack_public_path__ + "img/san_sebastian.b19ec14d.jpg";